import { ServerResponse } from 'http';

export const redirect = (res: ServerResponse, path: string) => {
    try {
        res.statusCode = 302;
        res.setHeader('Location', path);
        res.end();
    } catch (err) {
        console.log(-1, 'error redirect | ', err);
    }
};

export const redirect301 = (res: ServerResponse, path: string) => {
    try {
        res.statusCode = 301;
        res.setHeader('Location', path);
        res.end();
    } catch (err) {
        console.log(-1, 'error redirect | ', err);
    }
};

export const replaceUrl = (destUrl: string = '/') => {
    (window as any).location.replace(destUrl);
};
